import { Component, TemplateRef, Output, EventEmitter, OnInit, Input, ViewChild } from '@angular/core';
import { AgGridEvent, GridApi, ColumnApi, ColDef, RowClickedEvent, FilterChangedEvent, GridOptions, RowNode, RowSelectedEvent, GetRowIdFunc, GetRowIdParams, GridReadyEvent, IRowNode } from "ag-grid-community";
import { FormGroup, UntypedFormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DialogsService } from '@app/core/services/dialogs.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationManagementDialogService } from '../notification-management-dialog/notification-management-dialog.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreventiveMaintenanceService } from '@app/preventiveMaintenance/preventiveMaintenance.service';
import { FrequencyType } from '@app/core/models/frequencyType';
import {ButtonRendererComponent} from "@app/core/component/buttonRenderer/buttonRenderer.component"
import { FilesDialogComponent } from '../files-dialog/files-dialog.component';
import { NotificationType } from '@app/core/models/notificationType';
import { RoleManagementService } from '@app/roleManagement/roleManagement.service';
import { Role } from '@app/core/models/role';
import { NotificationSchedule } from '@app/core/models/notificationSchedule';
import { DropDownRendererComponent } from '@app/core/component/dropDownRenderer/dropDownRenderer.component';
import { DropDownOption } from '@app/core/models/dropDownOption';
import { GridActionComponent } from '@app/shared/components/grid-action/grid-action.component';
import { ToastrService } from 'ngx-toastr';
import { NotificationLog } from '@app/core/models/notificationLog';
import { DatePipe } from '@angular/common';
import { UnitFilePortalDialogService } from './unitFile-portal-dialog.service';
import { UnitFileUploadDialogComponent } from '../unitFile-upload-dialog/unitFile-upload-dialog.component';
import { UnitFile } from '@app/core/models/unitFile';
import { AuthService } from '@app/core/services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'unitFile-Portal-dialog',
  templateUrl: './unitFile-portal-dialog.component.html',
  styleUrls: ['./unitFile-portal-dialog.component.css'],
  providers: [DatePipe]
})
export class UnitFilePortalDialogComponent implements OnInit { 

  @Input()
  propertyId!: number;
  @Output() closeModalEvent: EventEmitter<any> = new EventEmitter();
 
  public eventCloseModal: EventEmitter<any> = new EventEmitter();
  
  private gridApi!: GridApi;
  public newTrackingItemShowDiv: boolean = false;
  public unitFileTypeOptions: DropDownOption[] = [];
  public rolesOptions: DropDownOption[] = [];
  public unitFileList: UnitFile[] = [];
  public notificationLogList:NotificationLog[]=[];
  public repeatedForms: any;
  public params:any;
  public gridOptions: GridOptions;
  public hasFilters: boolean = false;
 
  public isDownloadVisible:boolean = false;
  public isAdmin: boolean = false;
  public isSpecialAdmin: boolean = false;
  
  public defaultColDef = {
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    sortable: true,
    filter: true
  }

 
   public frameworkComponents: any;
  

   public unitFileListColumns: ColDef[] = [    
    { headerName: 'File Name', field: 'name'},
    { headerName: 'Uploaded Date', field: 'uploadedOn' },
    { headerName: 'Upload User', field: 'uploadedByName'},
    { headerName: 'Actions', cellRenderer: 'actions', cellRendererParams: { onClick: this.onGridAction.bind(this),  isSaveVisible: false, isDownloadVisible:true , isDeleteVisible:true}, width: 120  }
    //{ headerName: '', cellRenderer: 'actions', pinned: 'right', width: 90, suppressSizeToFit: true }
  ];

 
  
  public context: any;

  constructor(
    private modalRef: BsModalRef,
    private fb: UntypedFormBuilder,
    private modalService: BsModalService,
    public activeModal: NgbActiveModal,
    public ngbModal: NgbModal,
    private unitFilPortaleService: UnitFilePortalDialogService,
    private dialogsService: DialogsService,
    public filesDialogComponent: FilesDialogComponent,
    private toastr: ToastrService,
    private authService: AuthService,
    private spinnerService: NgxSpinnerService
    
    ) { 

      this.gridOptions = {
        paginationAutoPageSize: true,
        
      }
      this.frameworkComponents = {
        actions: GridActionComponent,
        dropDownEditor: DropDownRendererComponent, 
      }
      this.context = {
        componentParent: this
      }

  }
 
  
  ngOnInit() {

    this.isAdmin = this.authService.isAuthUserInRole("Admin");
    this.isSpecialAdmin = this.authService.isAuthUserInRole("Special");

    
    this.isDownloadVisible = (this.isAdmin || this.isSpecialAdmin);
    
    this.getUnitFileTypes();
    
   
  }

  public getRowId: GetRowIdFunc = (params: GetRowIdParams) => params.data.id;

  public onHeaderChange(){

  }


  //TRACKING ITEM METHODS//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  
  public closeModal(){
    
    this.activeModal.dismiss();
    this.eventCloseModal.emit({});
  }

  public removeAllUnitFiles()
  {
    const title = 'Remove All Unit Files';
    const message = `Are you sure you want to remove all unit files for this property?`;
    this.dialogsService.confirmation(title, message)
      .then(() => {
        return this.unitFilPortaleService.removeAllUnitFiles(this.propertyId).subscribe(() => {
          this.getUnitFiles(this.propertyId);
        },(err)=>{
          this.showErrorMessage(err.error.msg);
        });
      }, () => { });



    
  }

  public downloadAllUnitFiles()
  {
    this.spinnerService.show();
    return this.unitFilPortaleService.downloadAllUnitFiles(this.propertyId).subscribe((res: any) => {
      const fileType = res.headers.get('Content-Type')
      const blob = new Blob([res.body], { type: fileType});
      const fileURL = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style.cssText = "display:none";
      a.href = fileURL;
      a.setAttribute('download', "UnitFiles.zip");
     
      a.click();
      this.spinnerService.hide();
      window.URL.revokeObjectURL(fileURL);
      
      this.getUnitFiles(this.propertyId);
    },()=>{
      this.spinnerService.hide();
      this.showErrorMessage('Unexpected error');
    });
  }

  public openUploadFileModal()
  {
    const modalRef = this.ngbModal.open(UnitFileUploadDialogComponent,
      {
        backdrop: true,
        size: 'lg',
        windowClass: 'modal-xl',
        beforeDismiss: (): any => {
         
          return true;
        }
      });

    modalRef.componentInstance.propertyId = this.propertyId;
   
    modalRef.result.then((_data: any) => {
      this.getUnitFiles(this.propertyId);
    }, (_reason: any) => {
      this.getUnitFiles(this.propertyId);
    });
    return modalRef.result;
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  //FREQUENCY TYPE METHODS//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



  
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private getUnitFileTypes(){
    this.unitFilPortaleService.getUnitFileTypes().subscribe(res=>{
      this.unitFileTypeOptions = [];
      res.forEach(e => {
        this.unitFileTypeOptions.push({
          id: e.unitFileTypeId,
          name: e.name
        })
    })
    if(this.propertyId>0 )
    {
      this.getUnitFiles(this.propertyId);
    }
  });
}


 

  private getUnitFiles(propertyId:number) {
    this.unitFileList = [];
    this.unitFilPortaleService.getUnitFiles(propertyId)
    .subscribe((data) => {
      this.unitFileList = data.list;
     
    });
  }



  


  onColumnVisible(e: any) {
    console.log(e);
  }

  onGridReady(params) { 
   
    params.api.sizeColumnsToFit(); 
  } 

  onLogGridReady(params) { 
    this.gridApi = params.api;
    params.api.sizeColumnsToFit(); 
  } 

  public onGridAction(event: any){
  
    switch (event.actionType) {
      case 'save': {
        const unitFile = event.rowData as UnitFile;
        this.updateUnitFile(unitFile);
        break;
      }
      case 'download': {        
        const unitFile = event.rowData as UnitFile;
        this.downloadUnitFile(unitFile);
        break;
      }
      case 'delete': {        
        const unitFile = event.rowData as UnitFile;
        this.removeUnitFile(unitFile);
        break;
      }
    }
    
   
 
  }

  
  private updateUnitFile(unitFile:UnitFile)
  {
    return this.unitFilPortaleService.updateUnitFile(unitFile).subscribe(() => {
      
    },(err)=>{
      this.showErrorMessage(err.error.msg);
    });
  }

  private downloadUnitFile(unitFile:UnitFile)
  {
   
     this.unitFilPortaleService.downloadUnitFile(unitFile.filePath).subscribe((res: any) => {
       const fileType = res.headers.get('Content-Type')
       const blob = new Blob([res.body], { type: fileType});
       const fileURL = window.URL.createObjectURL(blob);
       const a = document.createElement("a");
       document.body.appendChild(a);
       a.style.cssText = "display:none";
       a.href = fileURL;
       a.setAttribute('download', unitFile.name);
      
       a.click();
       window.URL.revokeObjectURL(fileURL);
     
     },() => {
      
     });
    
  }


  private removeUnitFile(unitFile:UnitFile)
  {

    const title = 'Remove Unit File';
    const message = `Are you sure you want to remove unit file?`;
    this.dialogsService.confirmation(title, message)
      .then(() => {
        return this.unitFilPortaleService.removeUnitFile(unitFile.unitFileId).subscribe(() => {
          this.getUnitFiles(this.propertyId);
        },(err)=>{
          this.showErrorMessage(err.error.msg);
        });
      }, () => { });
   
  }



  onFilterChanged(params: FilterChangedEvent) {
    const filterModel = params.api.getFilterModel();
    this.hasFilters = Object.keys(filterModel).length > 0;
  }

  clearFilters() {
    this.gridApi.setFilterModel({});
  }

  showErrorMessage(message:string) {
    return this.dialogsService.error(message)
  }

}